interface Item {
  [key: string]: any;
}

// 将API所需的蛇形数据转换成小驼峰，支持递归处理任意深度的嵌套结构
export function snakeToCamel(obj: any, convertNull = true) {
  if (obj === null || obj === undefined) {
    return convertNull ? {} : obj;
  }
  const convertToCamelCase = (str: string) => {
    return str.replace(/_([a-z])/g, (match, letter) => {
      return letter.toUpperCase();
    });
  };

  const camelCaseObj: any = Array.isArray(obj) ? [] : {};

  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === "object") {
      camelCaseObj[convertToCamelCase(key)] = snakeToCamel(
        obj[key],
        convertNull
      );
    } else {
      camelCaseObj[convertToCamelCase(key)] = obj[key];
    }
  });

  return camelCaseObj;
}

// 将小驼峰参数转换成API所需的蛇形数据，支持递归处理任意深度的嵌套结构
export function camelToSnake(obj: any): any {
  function transformCamelToSnake(str: any) {
    return str.replace(/[A-Z]/g, (match: any) => "_" + match.toLowerCase());
  }

  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => camelToSnake(item));
  }

  if (typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        transformCamelToSnake(key),
        camelToSnake(value),
      ])
    );
  }

  return obj;
}

export function convertArrayData<K, T extends Item>(data: T[]): K[] {
  return data.map((item) => {
    const newItem: Item = {};

    Object.entries(item).forEach(([key, value]) => {
      const newKey = key.replace(/_([a-z])/g, (_, letter) =>
        letter.toUpperCase()
      );

      newItem[newKey] = Array.isArray(value) ? convertArrayData(value) : value;
    });

    return newItem as K;
  });
}
